export default __webpack_public_path__ + "resources/icons/d131-b201.webp";